module.exports = __webpack_public_path__ + "img/Logo-CDEA.73ab9239.png";